import { z } from 'zod/v4';

import { endpoint } from '../http/endpoint';
import {
    OfferImportContextCreationDTORuntype,
    OfferImportContextDTORuntype,
    OfferImportContextUpdateDTORuntype,
} from './offerImportContextBackendTypes';

export const offerImportContextEndpoints = {
    'GET /offer-import-contexts': endpoint({
        description: 'Retrieve a list of offer import contexts',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: z.object({
            items: z.array(OfferImportContextDTORuntype),
        }),
    }),
    'POST /offer-import-contexts': endpoint({
        description: 'Create a new offer import context',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: OfferImportContextCreationDTORuntype,
        responseBody: OfferImportContextDTORuntype,
        invalidates: ['GET /offer-import-contexts', 'GET /offer-import-contexts/:id'],
    }),
    'GET /offer-import-contexts/:id': endpoint({
        description: 'Retrieve a single offer import context',
        pathParams: z.object({
            id: z.string().uuid(),
        }),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: OfferImportContextDTORuntype,
    }),
    'PATCH /offer-import-contexts/:id': endpoint({
        description: 'Edit an offer import context',
        pathParams: z.object({
            id: z.string().uuid(),
        }),
        queryParams: z.undefined(),
        requestBody: OfferImportContextUpdateDTORuntype,
        responseBody: OfferImportContextDTORuntype,
        invalidates: ['GET /offer-import-contexts', 'GET /offer-import-contexts/:id'],
    }),
    'DELETE /offer-import-contexts/:id': endpoint({
        description: 'Delete an offer import context',
        pathParams: z.object({
            id: z.string().uuid(),
        }),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: z.unknown(),
        invalidates: ['GET /offer-import-contexts', 'GET /offer-import-contexts/:id'],
    }),
};
